import {
  Autocomplete,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { snackbarUtils } from "../../utils";
import { useUsers } from "../../hooks/useUsers";
import {
  useOrganisations,
  useUpdateOrganisationMembers,
} from "../../hooks/useOrganisations";
import { useOrganisationMembers } from "../../hooks/useOrganisations";

export default function AddOrganisationMembersDialog(props) {
  const { open, handleClose, organisation_id } = props;

  const { data: organisationMembersData } = useOrganisationMembers(
    organisation_id,
    { enabled: !!organisation_id }
  );
  const [organisationMembers, setOrganisationMembers] = useState([]);

  useEffect(() => {
    if (organisationMembersData) {
      setOrganisationMembers(
        organisationMembersData.map((member) => member.id)
      );
    }
  }, [organisationMembersData]);

  const updateOrganisationMembersMutation = useUpdateOrganisationMembers();

  const updateOrganisationMembers = () => {
    updateOrganisationMembersMutation.mutate(
      {
        organisationId: organisation_id,
        members: organisationMembers,
      },
      {
        onSuccess: () => {
          snackbarUtils.updateMessage("Organisation members updated");
          handleClose();
        },
        onError: () => {
          snackbarUtils.updateMessage("Organisation members update error");
        },
      }
    );
  };

  const { data: users } = useUsers();
  const { data: organisations } = useOrganisations();

  const [organisation_name, setOrganisationName] = useState("");

  useEffect(() => {
    if (organisations?.length) {
      let filtered = organisations.filter((organisation) => {
        // eslint-disable-next-line
        return organisation.id == parseInt(organisation_id);
      });

      if (filtered && filtered.length) {
        setOrganisationName(filtered[0].name);
      }
    }
  }, [organisations, organisation_id]);

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth={true}>
      <DialogTitle>Manage {organisation_name} Members</DialogTitle>
      <DialogContent>
        <FormControl fullWidth>
          {
            //autocomplete, when changed, update the organisationMembers state with just the id of the user, use this as value and name as display
          }
          <Autocomplete
            multiple
            id="tags-standard"
            options={users}
            getOptionLabel={(option) => option.email}
            defaultValue={organisationMembers}
            onChange={(event, value) => {
              if (value) {
                setOrganisationMembers(
                  value.map((user) => {
                    return user.id;
                  })
                );
              } else {
                setOrganisationMembers([]);
              }
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="standard"
                label="Members"
                placeholder="Members"
              />
            )}
          />
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={handleClose}>
          Cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={updateOrganisationMembers}
        >
          Update
        </Button>
      </DialogActions>
    </Dialog>
  );
}
